import { Injectable } from '@angular/core';
import { ModalCarbonCreditDetailComponent } from 'src/app/components/modal-carbon-credit-detail/modal-carbon-credit-detail.component';
import { ModalConfirmationComponent } from 'src/app/components/modal-confirmation/modal-confirmation.component';
import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { AppModalOverlayRef, AppModalService } from 'src/app/shared/services/app-modal.service';

@Injectable({
  providedIn: 'root'
})
export class CarbonModalService {
  constructor(private readonly modalService: AppModalService) {}

  openCarbonCreditGetListError(){
    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'error',
      modalType: 'info',
      title: 'Erro.',
      content: 'Não foi possível carregar a lista',
      closeButton: true,
    })
  }

  openCarbonCreditDetailModal(carbon: CarbonCredit): void {
    this.modalService.open(ModalCarbonCreditDetailComponent, {
      carbon,
      hasBackdrop: true,
      closeOnEsc: true,
      closeButton: false,
      size: 'large',
      theme: 'light',
    });
  }

  openOperationDetailModal(operation: CarbonOperation): void {
    this.modalService.open(ModalConfirmationComponent, {
      title: 'Detalhes do Crédito de Carbono',
      modalTitleType: 'pattern',
      closeButton: true,
      content: `
        <div class='row ml-3 mb-2'>
          <b>Tipo da operação</b>: ${operation.typeCode ?? ''}
        </div>
        <div class='row ml-3 mb-2'>
          <b>Código da operação</b>: ${operation.operationCode ?? ''}
        </div>
        <div class='row ml-3 mb-2'>
          <b>Data de emissão</b>: ${operation.insertDate ?? ''}
        </div>
        <div class='row ml-3 mb-2'>
          <b>Detentor</b>: ${operation.holderCode ?? ''}
        </div>
        <div class='row ml-3 mb-2'>
          <b>Adquirente</b>: ${operation.purchaserCode ?? ''}
        </div>
        <div class='row ml-3 mb-2'>
          <b>Quantidade de crédito</b>: ${operation.creditQuantity ?? ''}
        </div>
      `
    })
  }

  openOperationConfirmationModal(operation: CarbonOperation, confirmation: boolean): AppModalOverlayRef {
   return  this.modalService.open(ModalConfirmationComponent, {
      title: confirmation ? 'Confirmação' : 'Rejeitar',
      closeButton: true,
      modalTitleType: 'success',
      modalType: 'confirmation',
      content: confirmation ? 'Deseja aprovar esta operação?' : 'Deseja rejeitar esta operação?',
    })
  }

  openCarbonCreditConfirmationModal(isApprove: boolean): AppModalOverlayRef {
    return  this.modalService.open(ModalConfirmationComponent, {
      title: isApprove ? 'Confirmação' : 'Cancelamento',
      closeButton: true,
      modalTitleType: isApprove ? 'success' : 'error',
      modalType: 'confirmation',
      content: isApprove ? 'Deseja autorizar esta operação?' : 'Deseja rejeitar esta operação?'
     })
   }
}
